
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3404_10326)"}},[_c('path',{attrs:{"d":"M9.7 13.269c.734-.77.933-1.877.64-2.94l2.551-2.674.189.18a.783.783 0 001.081-1.133l-3.4-3.244a.783.783 0 00-1.08 1.134l.188.18-2.551 2.674c-1.075-.244-2.172.007-2.907.777l2.267 2.162-1.442 1.511a.524.524 0 00.017.738c.208.198.54.19.738-.017l1.442-1.51L9.7 13.268z","fill":"#0064FF"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3404_10326"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(43.658 4.325 10.797)","d":"M0 0h12.53v12.53H0z"}})])])])
          )
        }
      }
    